import React from 'react';
import { Table, Tbody, Tr, Td } from 'react-super-responsive-table';
import { useNavigate } from 'react-router-dom';
import "../css/testimonial.css";
import Loading from '../components/Loading';
import Userimg from '../../../images/user.png';

const UserListView = ({ posts, loading }) => {
    const navigate = useNavigate();
    if (loading) {
        return <Loading size={100} />;
    }

    const handleEdit = (postId, userType) => {
        localStorage.setItem('postId', postId);
        localStorage.setItem('userType', userType);
        if (userType === 'Student') {
            navigate(`/students/view-profile/${postId}`);
        } else {
            navigate(`/employee/view-profile/${postId}`);
        }
    };

    const handleDelete = (postId, userType) => {

    }

    return (
        <Table className="responsiveTable">
            <Tbody>
                {posts.map(post => (
                    <Tr key={post.id}>
                        <Td style={{ width: '100px' }}>
                            <img className="rounded-corners" src={post.image ? `https://yesedacademy.com/database/${post.image}` : Userimg} alt="avatar" style={{ width: 50 }} />
                        </Td>
                        <Td>
                            <p className="name">{post.name}</p>
                            <p className="designation">{post.role}</p>
                        </Td>
                        <Td className="testimonial">
                            <p className="name">{post.email_address}</p>
                            <p className="name">+{post.mobile_ISD} {post.mobile}</p>
                        </Td>
                        <Td className="testimonial">
                            <p className="name">Date of joining : {post.join_date}</p>
                            {post.resign_date && <p className="name">Resigned Date : {post.resign_date}</p> }
                        </Td>
                        <Td className="testimonial">
                            <p className="name">Status : {post.resign_date? <span style={{ color: 'red' }}> Resigned </span> :  <span style={{ color: 'green' }}> Employed </span>}</p>
                            
                        </Td>
                        <Td>
                            <button onClick={() => handleEdit(post.id, post.user_type)}>View Profile</button>
                        </Td>
                       
                    </Tr>
                ))}
            </Tbody>
        </Table>
    );
};

export default UserListView;
